import React from 'react';
import { createIcon } from './create-icon';
import './icon-close.scss';

export const IconClose = createIcon(<div className="icon-close" />);
